export default "__VITE_ASSET__DAM_u8$y__"